import api from './axios';

// Authentication
export const login = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  return response.data;
};

export const logout = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const getMe = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const updatePassword = async (currentPassword, newPassword) => {
  const response = await api.patch('/auth/update-password', {
    currentPassword,
    newPassword,
  });
  return response.data;
};

export const refreshToken = async () => {
  const response = await api.post('/auth/refresh-token');
  return response.data;
};

const authService = {
  login,
  logout,
  getMe,
  updatePassword,
  refreshToken,
};

export default authService;
